/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Suspense, lazy } from 'react';
import { DestinationAccordionContainerEnhancedProps } from './DestinationAccordionContainerEnhanced.types';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import DestinationAccordionContainerEnhancedMock from './__mock__/DestinationAccordionContainerEnhanced.mock';

export const DestinationAccordionContainerEnhancedConfig = {
  emptyLabel: 'DestinationAccordionContainerEnhanced',
  isEmpty: false,
  resourceType: `mi-aem-offers-spa/components/DestinationAccordionContainerEnhanced`,
};

export const DestinationAccordionComp: React.FC<DestinationAccordionContainerEnhancedProps> = props => {
  const DestinationAccordionContainerEnhancedWrapper = lazy(
    () => import('./DestinationAccordionContainerEnhancedWrapper')
  );

  if (props?.isAuthorMode) {
    console.log("Author mode Destination Acc props >> ", props);
    // const DestinationAccordionContainerEnhancedMock = await import('./__mock__/DestinationAccordionContainerEnhanced.mock');
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <Suspense fallback={<></>}>
        <DestinationAccordionContainerEnhancedWrapper {...props} {...DestinationAccordionContainerEnhancedMock} />
      </Suspense>
    );
  }
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <Suspense fallback={<></>}>
      <DestinationAccordionContainerEnhancedWrapper {...props} />
    </Suspense>
  );
};
// Use named rather than default exports.
export const DestinationAccordionContainerEnhanced = (props: any) => (
  <div
    id="destination-Accordion"
    data-testid="destination-DestinationAccordion"
    data-component-name="o-destination-DestinationAccordion"
  >
    <EditableComponent config={DestinationAccordionContainerEnhancedConfig} {...props}>
      <DestinationAccordionComp {...props} />
    </EditableComponent>
  </div>
);
